import React from 'react';
import { Helmet } from 'react-helmet';
import ContactForm from './components/ContactForm';

class BookAnAppraisal extends React.Component {
    render() {
        return (
            <>
                <Helmet>
                    <title>Book An Appraisal - Partners Real Estate</title>
                </Helmet>

                <ContactForm
                    primary = {true}
                    appraisal = {true}
                    heading = "Book A Free Property Appraisal"
                    subheading = "You are just a few clicks away from booking your free property appraisal."
                />
            </>
        );
    }
}

export default BookAnAppraisal;
